import mixpanel from 'mixpanel-browser'
import { createContext } from 'react'

export const MixPanelContext = createContext(mixpanel)

export const OPTIMIZELY_USER_ID_STORAGE_KEY = 'optimizelyUserId'
